/**
 * Decides whether Ryn Replay capture should be paused because a heavy page host
 * is mounted in the document (#31398).
 *
 * Focus-scoped pause only fires once the user focuses into the grid, so the
 * Equipment Usage *initial* grid render (and any off-focus Kendo churn) still
 * hits rrweb. Presence pause covers the whole visit: pause while any configured
 * host is in the DOM, resume when the last one is gone.
 *
 * Pure on purpose so the match is unit-tested without a live recorder. The
 * service watches the DOM with a count-only MutationObserver (never reading
 * record contents) and routes the boolean through the shared auto-pause set.
 */
export function isHeavyElementPresent(
  root: ParentNode | null | undefined,
  heavySelectors: readonly string[] | undefined
): boolean {
  if (!root || !heavySelectors || heavySelectors.length === 0) {
    return false;
  }
  if (typeof root.querySelector !== 'function') {
    return false;
  }

  return heavySelectors.some(
    (selector) => selector.length > 0 && root.querySelector(selector) != null
  );
}
